import { jwtDecode } from 'jwt-decode';
import React, { createContext, useContext, useState } from 'react';

interface AdminAuthContextValue {
    token: string | null;
    preAuthToken: string | null;
    isLoggedIn: boolean;
    setPreAuth: (token: string) => void;
    loginAdmin: (token: string) => void;
    logoutAdmin: () => void;
}

const AdminAuthContext = createContext<AdminAuthContextValue>({
    token: null,
    preAuthToken: null,
    isLoggedIn: false,
    setPreAuth: () => {},
    loginAdmin: () => {},
    logoutAdmin: () => {},
});

export const AdminAuthProvider = ({ children }: { children: React.ReactNode }) => {
    const [token, setToken] = useState<string | null>(() => {
        const t = localStorage.getItem('adminToken');
        if (!t) return null;
        try {
            const decoded = jwtDecode<{ exp: number }>(t);
            return Date.now() < decoded.exp * 1000 ? t : null;
        } catch {
            return null;
        }
    });
    const [preAuthToken, setPreAuthToken] = useState<string | null>(null);

    const isLoggedIn = token !== null;

    const setPreAuth = (t: string) => setPreAuthToken(t);

    const loginAdmin = (t: string) => {
        localStorage.setItem('adminToken', t);
        setToken(t);
        setPreAuthToken(null);
    };

    const logoutAdmin = () => {
        localStorage.removeItem('adminToken');
        setToken(null);
        setPreAuthToken(null);
    };

    return (
        <AdminAuthContext.Provider value={{ token, preAuthToken, isLoggedIn, setPreAuth, loginAdmin, logoutAdmin }}>
            {children}
        </AdminAuthContext.Provider>
    );
};

export const useAdminAuth = () => useContext(AdminAuthContext);

export default AdminAuthContext;
